/**
 * Shared Bengali keyword sets for /bn/* routes.
 * Mixed script on purpose: Bangladeshi searchers type both
 * Latin transliterations ("seo bangla") and Bangla script ("এসইও বাংলা").
 */
export const BN_BASE_KEYWORDS = [
  "seo bangla",
  "এসইও বাংলা",
  "bangla seo",
  "seo bangla tutorial",
  "seo shikha bangla",
  "digital marketing bangla",
  "ডিজিটাল মার্কেটিং বাংলা",
  "seo expert bangladesh",
  "এসইও এক্সপার্ট বাংলাদেশ",
  "seo bangladesh",
];

/** Bangla category name -> extra keywords for that topic. */
export const BN_CATEGORY_KEYWORDS: Record<string, string[]> = {
  "এসইও": ["seo bangla guide", "on page seo bangla", "technical seo bangla", "কীওয়ার্ড রিসার্চ বাংলা"],
  "ডিজিটাল মার্কেটিং": ["digital marketing bangla tutorial", "ডিজিটাল মার্কেটিং শেখা"],
  "সোশ্যাল মিডিয়া": ["facebook marketing bangla", "সোশ্যাল মিডিয়া মার্কেটিং বাংলা"],
  "ফ্রিল্যান্সিং": ["freelancing bangla", "ফ্রিল্যান্সিং শেখা"],
  "পেইড অ্যাডস": ["facebook ads bangla", "google ads bangla"],
  "কন্টেন্ট মার্কেটিং": ["content marketing bangla"],
  "ইমেইল মার্কেটিং": ["email marketing bangla"],
  "ই-কমার্স": ["ecommerce seo bangla", "f-commerce bangladesh"],
  "লোকাল SEO": ["local seo bangla", "google business profile bangla"],
};

/** Build a de-duplicated keywords string from the base set plus extras. */
export function bnKeywords(...extra: (string | string[] | undefined)[]) {
  const flat = extra.flatMap((e) =>
    typeof e === "string" ? e.split(",").map((s) => s.trim()) : (e ?? [])
  );
  return Array.from(new Set([...flat, ...BN_BASE_KEYWORDS].filter(Boolean))).join(", ");
}

/** Language meta tags shared by every /bn/* route. */
export const BN_LANG_META = [
  { name: "language", content: "Bengali" },
  { httpEquiv: "content-language", content: "bn-BD" },
  { property: "og:locale", content: "bn_BD" },
  { property: "og:locale:alternate", content: "en_US" },
];
